export enum reservationFormDetails {
  SET_RESERVATION_FORM_DETAILS = 'SET_RESERVATION_FORM_DETAILS',
  SET_RESERVATION_FORM_DETAILS_FAILED = 'SET_RESERVATION_FORM_DETAILS_FAILED',

  SET_BOOKING_DETAILS = 'SET_BOOKING_DETAILS',
  SET_BOOKING_DETAILS_FAILED = 'SET_BOOKING_DETAILS_FAILED',
}
